import React, { useState, useEffect } from "react";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel,
} from "@mui/material";
import { Tooltip } from "antd";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbDownAltRounded"
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import SearchIcon from "@mui/icons-material/Search";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import FileBase64 from "../../components/Upload/UploadFile";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import Util from "../../validation/index";
import CropOriginalIcon from '@mui/icons-material/CropOriginal';
import { partnerCashLiftReqList } from '../../redux/actions/cashLiftPartnerAction';
import { partnerCashLiftApproveRejectReqList } from '../../redux/actions/cashLiftApproveRejectPartnerAction'
import { partnerBankNameListReqList } from '../../redux/actions/bankNameListPartnerAction';
import { partnerBranchNameListReqList } from "../../redux/actions/branchNameListPartnerAction"
const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

function CashLifting() {
    const navigate = useHistory();
    const [notificationOpen, setNotificationOpen] = React.useState(false);
    // const [editNotification, setEditNotification] = useState(false);
    const [openRejectReason, setOpenRejectReason] = React.useState(false);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [isLoading, setIsLoading] = useState(true);
    const [getRemark, setGetRemark] = useState("");

    const [cashLiftingListStatus, setCashLiftingListStatus] = useState(false);
    const [cashLiftingListArray, setCashLiftingListArray] = useState("");

    const [getCashLiftApprovedorRejectStatus, setGetCashLiftApprovedorRejectStatus] =
        useState(false);
    const [getCashLiftApprovedorRejectArray, setGetCashLiftApprovedorRejectArray] =
        useState("");
    const [modalRequestid, setmodalRequestid] = useState('');

    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;
    const classes = useStyles();
    const dispatch = useDispatch();

    const [show, setShow] = useState(false);
    const [imgModal, setImgModal] = useState("")
    const showModal = (slipImage) => {
        setShow(true);
        setImgModal(slipImage)

    }

    const [user, setUser] = useState({
        bankNameSearch: "",
        branchNameSearch: ""
    });

    const { bankNameSearch, branchNameSearch } = user;

    const onInputChange = ({ target: { name, value } }, type) => {
        const obj = {
            ...user
        };

        if (type == "number") {
            obj[name] = Util.verifyMobile(value) ? value : obj[name];
        } else if (type == "alphabet") {
            obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
        } else if (type == "both") {
            obj[name] = Util.alphaNumeric(value) ? value : obj[name];
        } else {
            obj[name] = value
        }
        setUser(obj);
    };
    const handleClose = () => {
        // setAddOpen(false);
        setShow(false)
        setOpenRejectReason(false)
        // setRequestInput({
        // 	bankName: "",
        // 	branchName: "",
        // 	accountNum: "",
        // 	amount: ""
        // });
    };

    const partnerCashLiftingListRes = useSelector(
        ({ partnerCashLiftLists }) => partnerCashLiftLists
    );
    const partnerCashLiftApproveRejectRes = useSelector(
        ({ partnerCashLiftApproveRejectLists }) => partnerCashLiftApproveRejectLists
    );

    const partnerBankNameRes = useSelector(({ partnerBankNameLists }) => partnerBankNameLists);

    const partnerBranchNameRes = useSelector(({ partnerBranchNameLists }) => partnerBranchNameLists);


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleChange = ({ target: { name, value } }) => {
        if (name === "GetRemark") {
            setGetRemark(value);
        }
    };
    const rejectOpenModal = (requestId) => {
        setOpenRejectReason(true);
        setmodalRequestid(requestId);
    }
    const handleNoticationClose = () => {
        setNotificationOpen(false);
        // setOpenRejectReason(true);
        setOpenRejectReason(false)


    };
    const PartnerCashLiftingListReq = () => {
        setCashLiftingListStatus(true);
        let req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                bankName: bankNameSearch.split(",")[1],
                branchName: branchNameSearch.split(",")[1]

            }
        };
        dispatch(partnerCashLiftReqList(req, authToken));

    };

    const PartnerCashLiftingListFunc = () => {
        if (cashLiftingListStatus) {
            if (partnerCashLiftingListRes.data.status == "success") {
                setCashLiftingListArray(
                    [].concat(partnerCashLiftingListRes.data.errorList)
                );
                setIsLoading(false);
            }
            if (partnerCashLiftingListRes.data.status == "failed") {
                setCashLiftingListArray(partnerCashLiftingListRes.data);
                setIsLoading(false);
                if (
                    partnerCashLiftingListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    partnerCashLiftingListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };
    useEffect(() => {
        PartnerCashLiftingListFunc();
    }, [partnerCashLiftingListRes.data.status]);

    useEffect(() => {
        if (partnerCashLiftingListRes.data.status == "success") {
            setPage(0);
        }
    }, [partnerCashLiftingListRes.data.status]);

    const PartnerBankNameReq = () => {
        let req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId
            }
        };

        dispatch(partnerBankNameListReqList(req, authToken));
    };

    const PartnerBranchNameReq = () => {
        let request = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                // bankCode: bankName.split(",")[0] || bankNameSearch.split(",")[0]
                bankCode: bankNameSearch.split(",")[0]

            }
        };

        dispatch(partnerBranchNameListReqList(request, authToken));
    };


    useEffect(() => {
        setUser({
            bankNameSearch: bankNameSearch,
            branchNameSearch: ""
        })

        // branchNameReq();
        PartnerBranchNameReq()
    }, [bankNameSearch]);
    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            PartnerCashLiftingListReq();
            PartnerBankNameReq()
        }
    }, [regenerateTokenRes.data.status]);



    const handleAcceptOrRejectReq = (
        action,
        requestId,
        // status,
        // remark,
        withdrawStatus
    ) => {
        setGetCashLiftApprovedorRejectStatus(true)
        console.log(action, requestId, withdrawStatus, "action")

        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                action: action,
                requestId: requestId,
                status: withdrawStatus,
                //status: status === "Approval Pending" ? "approved" : "rejected",
                remark: getRemark || "-"
            }
        };
        dispatch(partnerCashLiftApproveRejectReqList(req, authToken));

        setGetRemark('')

    }
    const getCashLiftApproveRejectResFunc = () => {
        if (getCashLiftApprovedorRejectStatus) {
            if (
                partnerCashLiftApproveRejectRes.data.status == "success"
            ) {
                setGetCashLiftApprovedorRejectArray(partnerCashLiftApproveRejectRes.data);
                setNotificationOpen(true);
                PartnerCashLiftingListReq()
            }
            if (
                partnerCashLiftApproveRejectRes.data.status == "failed"
            ) {
                setGetCashLiftApprovedorRejectArray(partnerCashLiftApproveRejectRes.data);
                setNotificationOpen(true);
            }
        }
    };

    useEffect(() => {
        getCashLiftApproveRejectResFunc();
    }, [partnerCashLiftApproveRejectRes.data.status]);
    return (
        <>
            <Layout>
                <Card>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                variant="standard"
                                label="Bank Name"
                                fullWidth={true}
                                name="bankNameSearch"
                                defaultValue={bankNameSearch || ""}
                                onChange={(e) => onInputChange(e, "")}
                            >
                                <MenuItem value="" selected="">
                                    Select Bank Name
                                </MenuItem>
                                {partnerBankNameRes.success &&
                                    []
                                        .concat(partnerBankNameRes.data.list)
                                        .map((x) => <MenuItem value={x.code + "," + x.name}>{x.name}</MenuItem>)}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                label="Branch Name"
                                variant="standard"

                                fullWidth={true}
                                name="branchNameSearch"
                                defaultValue={branchNameSearch || ""}
                                onChange={(e) => onInputChange(e, "")}
                            >
                                <MenuItem
                                    value=""
                                    selected=""
                                >
                                    Select Branch Name
                                </MenuItem>
                                {partnerBranchNameRes.success &&
                                    []
                                        .concat(partnerBranchNameRes.data.list)
                                        .map((x) => <MenuItem value={x.code + "," + x.name}>{x.name}</MenuItem>)}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={PartnerCashLiftingListReq}
                            >
                                Search <SearchIcon />
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>

                {isLoading ? (
                    <LoadingSpinner />
                ) : cashLiftingListArray.length == undefined ||
                    !cashLiftingListStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}>
                                    Summary Data
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <div>
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}>
                                        Report Table
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="text-nowrap my-3">
                                    <Table className={classes.table}>
                                        <TableHead>
                                            <TableRow className="tableHeaderColor">
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Request ID{" "}
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Dealer ID
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Dealer Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Bank Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Branch Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Account Number
                                                </TableCell>
                                                {/* <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Account Type
                                                </TableCell> */}

                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Amount
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    slip img
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Status
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Remark
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Action
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {cashLiftingListArray &&
                                                []
                                                    .concat(cashLiftingListArray)
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">
                                                                {row.requestId}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.fromCustId}
                                                            </TableCell>
                                                            <TableCell align="center">{row.fromName}</TableCell>
                                                            <TableCell align="center">
                                                                {row.bankName}
                                                            </TableCell>
                                                            <TableCell align="center">{row.branchName}</TableCell>
                                                            <TableCell align="center">{row.bankAccountNumber}</TableCell>
                                                            <TableCell align="center">{row.amount}</TableCell>


                                                            <TableCell align="center">
                                                                {row.qrcode ? <CropOriginalIcon style={{ cursor: 'pointer' }} onClick={() => showModal(row.qrcode)} /> : "-"}
                                                                {/* {row.qrCode && <CropOriginalIcon style={{ cursor: 'pointer' }} onClick={showModal}></CropOriginalIcon> || "-"} */}
                                                                {/* <img
																	src={`data:image/jpeg;base64,${row.qrcode}`}
																	style={{ maxWidth: "100%" }}
																/> */}

                                                            </TableCell>
                                                            <TableCell align="center">{row.status}</TableCell>
                                                            <TableCell align="center">{row.remark}</TableCell>
                                                            {/* <TableCell align="center">
                                                                {row.statusDescription}
                                                            </TableCell> */}
                                                            {/* {row.status == "Approval Pending" && (
                                                                <>
                                                                    <TableCell align="center">
                                                                        <Tooltip title="Approve">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "8px",
                                                                                    width: "50px"
                                                                                }}
                                                                                onClick={() =>
                                                                                    handleAcceptOrRejectReq(
                                                                                        // row.action,
                                                                                        row.requestId,
                                                                                        // row.status,
                                                                                        // row.remark,
                                                                                        "Approved",

                                                                                    )
                                                                                }
                                                                            >
                                                                                {
                                                                                    <ThumbUpAltRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "20px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>

                                                                        <Tooltip title="Reject">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "4px",
                                                                                    width: "48px",
                                                                                    marginLeft: "5px"
                                                                                }}
                                                                                onClick={() =>
                                                                                    handleAcceptOrRejectReq(
                                                                                        // row.action,
                                                                                        row.requestId,
                                                                                        // row.status,
                                                                                        // row.remark,
                                                                                        "Rejected",

                                                                                    )
                                                                                }
                                                                            >
                                                                                {
                                                                                    <ClearRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "28px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </>
                                                            )} */}

                                                            {row.status == "Review Pending" && (
                                                                <>
                                                                    <TableCell align="center">
                                                                        <Tooltip title="Approve">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "8px",
                                                                                    width: "50px"
                                                                                }}
                                                                                onClick={() =>
                                                                                    handleAcceptOrRejectReq(
                                                                                        row.status,
                                                                                        row.requestId,
                                                                                        // row.status,
                                                                                        // row.remark,
                                                                                        "Approval Pending",

                                                                                    )

                                                                                }

                                                                            >
                                                                                {
                                                                                    <ThumbUpAltRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "20px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>

                                                                        <Tooltip title="Reject">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "4px",
                                                                                    width: "48px",
                                                                                    marginLeft: "5px"
                                                                                }}
                                                                                // onClick={() =>
                                                                                //     handleAcceptOrRejectReq(
                                                                                //         row.action,
                                                                                //         row.requestId,
                                                                                //         row.status,
                                                                                //         row.remark,
                                                                                //         "reject",

                                                                                //     )
                                                                                // }
                                                                                onClick={() => {
                                                                                    rejectOpenModal(row.requestId)
                                                                                }}
                                                                            >
                                                                                {
                                                                                    <ClearRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "28px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </>
                                                            )}

                                                            {/* {row.status == "updated" && (
                                                                <>
                                                                    <TableCell align="center">
                                                                        <Tooltip title="Approve">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "8px",
                                                                                    width: "50px"
                                                                                }}
                                                                                onClick={() =>
                                                                                    handleAcceptOrRejectReq(
                                                                                        row.action,
                                                                                        row.requestId,
                                                                                        row.status,
                                                                                        row.remark,
                                                                                        "approve",

                                                                                    )
                                                                                }
                                                                            >
                                                                                {
                                                                                    <ThumbUpAltRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "20px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>

                                                                        <Tooltip title="Reject">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "4px",
                                                                                    width: "48px",
                                                                                    marginLeft: "5px"
                                                                                }}
                                                                                onClick={() =>
                                                                                    handleAcceptOrRejectReq(
                                                                                        row.action,
                                                                                        row.requestId,
                                                                                        row.status,
                                                                                        row.remark,
                                                                                        "reject",

                                                                                    )
                                                                                }
                                                                            >
                                                                                {
                                                                                    <ClearRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "28px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </>
                                                            )} */}

                                                            {row.status == "Approval Pending" && (
                                                                <>
                                                                    <TableCell align="center">
                                                                        <Tooltip title="Approve">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "8px",
                                                                                    width: "50px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ThumbUpAltRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "20px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>

                                                                        <Tooltip title="Reject">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "4px",
                                                                                    width: "48px",
                                                                                    marginLeft: "5px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ClearRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "28px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </>
                                                            )}

                                                            {row.status == "Approved" && (
                                                                <>
                                                                    <TableCell align="center">
                                                                        <Tooltip title="Approve">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "8px",
                                                                                    width: "50px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ThumbUpAltRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "20px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>

                                                                        <Tooltip title="Reject">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "4px",
                                                                                    width: "48px",
                                                                                    marginLeft: "5px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ClearRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "28px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </>
                                                            )}

                                                            {row.status == "Rejected" && (
                                                                <>
                                                                    <TableCell align="center">
                                                                        <Tooltip title="Approve">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "8px",
                                                                                    width: "50px"
                                                                                }}
                                                                                disabled
                                                                            >
                                                                                {
                                                                                    <ThumbUpAltRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "20px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>

                                                                        <Tooltip title="Reject">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "4px",
                                                                                    width: "48px",
                                                                                    marginLeft: "5px"
                                                                                }}
                                                                                disabled
                                                                            >
                                                                                {
                                                                                    <ClearRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "28px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </>
                                                            )}

                                                            {row.status == "reject" && (
                                                                <>
                                                                    <TableCell align="center">
                                                                        <Tooltip title="Approve">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "8px",
                                                                                    width: "50px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ThumbUpAltRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "20px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>

                                                                        <Tooltip title="Reject">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "4px",
                                                                                    width: "48px",
                                                                                    marginLeft: "5px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ClearRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "28px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </>
                                                            )}

                                                            {row.status == "approve" && (
                                                                <>
                                                                    <TableCell align="center">
                                                                        <Tooltip title="Approve">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "8px",
                                                                                    width: "50px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ThumbUpAltRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "20px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>

                                                                        <Tooltip title="Reject">
                                                                            <CustomButton
                                                                                style={{
                                                                                    padding: "4px",
                                                                                    width: "48px",
                                                                                    marginLeft: "5px"
                                                                                }}
                                                                                disabled={true}
                                                                            >
                                                                                {
                                                                                    <ClearRoundedIcon
                                                                                        style={{
                                                                                            color: "#fff",
                                                                                            fontSize: "28px"
                                                                                        }}
                                                                                    />
                                                                                }
                                                                            </CustomButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </>
                                                            )}
                                                        </TableRow>
                                                    ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={[].concat(cashLiftingListArray).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={handleChangePage}
                                        onChangeRowsPerPage={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                            </Grid>
                        </Card>
                    </div>
                )}
                <div>
                    <Dialog open={openRejectReason} onClose={handleClose}>
                        {/* <DialogTitle>Reject Document</DialogTitle>
                        
                        <hr /> */}
                        {/* <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton> */}
                        <DialogTitle style={{ width: "400px" }}>
                            Are you sure you want to reject the document?
                        </DialogTitle>
                        <DialogActions className="p-3">
                            <Grid item xs={12} md={12} lg={12}>
                                <div style={{ marginTop: "1.5rem" }}>
                                    <TextField
                                        required
                                        type="text"
                                        size="small"
                                        color="primary"
                                        autoFocus={true}
                                        label="Reject Reason"
                                        fullWidth={true}
                                        name="GetRemark"
                                        value={getRemark || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="text-right" style={{ marginTop: "2.5rem" }}>
                                    <CustomButton
                                        style={{
                                            padding: "8px",
                                            margin: "0 8px"
                                        }}
                                        variant="contained"
                                        // color="primary"
                                        // onClick={() => {

                                        //     setrejectdisabled(true);
                                        //     setpendingreject(true);
                                        //     setpendingapprove(true);
                                        // }}
                                        onClick={() =>
                                            handleAcceptOrRejectReq(
                                                // action,
                                                modalRequestid,
                                                // status,
                                                // remark,
                                                "Rejected",

                                            )
                                        }
                                    >
                                        OK
                                    </CustomButton>
                                </div>
                            </Grid>

                        </DialogActions>
                    </Dialog>
                </div>

            </Layout>

            <div>
                <Dialog open={show} onClose={handleNoticationClose}>
                    <DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
                    
                    >

                        <img
                            src={`data:image/jpeg;base64,${imgModal}`}
                            style={{ maxWidth: "100%" }}
                        />


                    </DialogContent>

                    <DialogActions style={{ justifyContent: "center" }}>
                        <CustomButton
                            style={{
                                padding: "8px"
                            }}
                            onClick={handleClose}
                        >
                            Close
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>


            {getCashLiftApprovedorRejectArray.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
                        
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {getCashLiftApprovedorRejectArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {getCashLiftApprovedorRejectArray.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
                        
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {getCashLiftApprovedorRejectArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default CashLifting






